import { define } from './define';

// Keys start with "settings.". Spanish first; English must have the same keys (TypeScript checks it).
// The brand's settings page: its sections, the agent, webhooks, Slack, tokens, the audit log and the readiness checks.
export const settings = define({
  es: {
    'settings.title': 'Ajustes',
    'settings.sections': 'Secciones de ajustes',
    'settings.needsAttention': '(necesita atención)',
    'settings.saved': 'Guardado',
    'settings.unsaved': 'Hay cambios sin guardar',
    'settings.discard': 'Descartar cambios',
    'settings.dismiss': 'Cerrar',
    'settings.done': 'Hecho',
    'settings.actions': 'Acciones',

    'settings.group.brand': 'Marca',
    'settings.group.automation': 'Automatización',
    'settings.group.control': 'Control',

    'settings.tab.general': 'General',
    'settings.tab.members': 'Miembros',
    'settings.tab.accounts': 'Cuentas',
    'settings.tab.schedule': 'Parrilla semanal',
    'settings.tab.agent': 'Agente',
    'settings.tab.webhooks': 'Webhooks',
    'settings.tab.prizes': 'Premios',
    'settings.tab.notifications': 'Slack',
    'settings.tab.tokens': 'Tokens de API',
    'settings.tab.media': 'Biblioteca de medios',
    'settings.tabDesc.media': 'Tus fotos y vídeos, y cuáles puede usar el agente en borradores',
    'settings.media.title': 'Tus originales',
    'settings.media.intro': 'Fotos y vídeos propios de la marca. Subir un archivo no autoriza nada: una persona decide, por cada archivo, si el agente puede usarlo en borradores, y puede retirarlo cuando quiera. Al permitirlo, el agente describe lo que ve en «Lo que ve el agente». Solo dirá de la foto lo que diga esa descripción, así que corrígela si algo no es así.',
    'settings.media.empty': 'Todavía no hay originales',
    'settings.media.emptyHint': 'Sube una foto o un vídeo propio y decide si el agente puede usarlo.',
    'settings.media.allowedCount': '{allowed} de {total} permitidos al agente',
    'settings.media.image': 'Imagen',
    'settings.media.video': 'Vídeo',
    'settings.media.allowed': 'Permitido al agente',
    'settings.media.allowedBy': 'por {who}, {when}',
    'settings.media.withdrawnBy': 'Retirado por {who}, {when}',
    'settings.media.notAllowed': 'No permitido al agente',
    'settings.media.uploadedBy': 'Subido por {who}, {when}',
    'settings.media.allow': 'Permitir en borradores',
    'settings.media.withdraw': 'Retirar permiso',
    'settings.media.archive': 'Archivar',
    'settings.media.archiveTitle': '¿Archivar «{name}»?',
    'settings.media.archiveConfirm': 'El agente deja de verlo. Las versiones que ya lo usan no cambian.',
    'settings.media.allowedToast': 'El agente ya puede usarlo',
    'settings.media.withdrawnToast': 'Permiso retirado',
    'settings.media.archivedToast': 'Archivado',
    'settings.media.uploaded': 'Original guardado. Decide ahora si el agente puede usarlo.',
    'settings.media.uploadTitle': 'Subir un original',
    'settings.media.uploadHint': 'PNG, JPEG o MP4 reales (se comprueba el archivo, no el nombre). Hasta 20 MB una imagen, 256 MB un vídeo.',
    'settings.media.fileAria': 'Archivo',
    'settings.media.upload': 'Subir',
    'settings.media.uploading': 'Subiendo…',
    'settings.media.progress.hashing': 'Calculando la huella… {pct}%',
    'settings.media.progress.uploading': 'Subiendo… {pct}%',
    'settings.media.progress.closing': 'Comprobando lo guardado…',
    'settings.media.sees': 'Lo que ve el agente',
    'settings.media.seesPending': 'El agente la describirá en su próxima vuelta.',
    'settings.media.seesByPerson': 'Corregido por {who}, {when}',
    'settings.media.seesByAgent': 'Escrito por el agente, {when}',
    'settings.media.correct': 'Corregir',
    'settings.media.describe': 'Describir',
    'settings.media.descriptionAria': 'Lo que hay en la foto',
    'settings.media.tagsAria': 'Etiquetas, separadas por comas',
    'settings.media.agentSuggested': 'El agente sugirió: {tags}. Escribe arriba solo las que sean ciertas.',
    'settings.media.save': 'Guardar',
    'settings.media.cancel': 'Cancelar',
    'settings.media.describedToast': 'Descripción guardada: el agente usará esta',
    'settings.tab.facts': 'Datos del negocio',
    'settings.tabDesc.facts': 'Lo que el agente sabe de tu negocio: solo datos aprobados, nunca inventados',
    'settings.facts.title': 'Datos del negocio',
    'settings.facts.intro': 'El agente planifica solo con los datos aprobados aquí y nunca inventa otros. Lo que pongas como «desconocido protegido» no lo afirmará nunca. Cada cambio es una revisión nueva que alguien debe aprobar.',
    'settings.facts.none': 'Todavía no hay datos aprobados',
    'settings.facts.approved': 'Revisión {n} aprobada por {who}, {when}',
    'settings.facts.formTitle': 'Editar',
    'settings.facts.businessName': 'Nombre del negocio',
    'settings.facts.category': 'Categoría',
    'settings.facts.goal': 'Objetivo',
    'settings.facts.audience': 'Público',
    'settings.facts.voice': 'Tono',
    'settings.facts.cta': 'Llamada a la acción',
    'settings.facts.protectedWordHint': "Evita '{word}' aquí: el agente no puede usar esa palabra en sus propios textos.",
    'settings.facts.protectedUnknowns': 'Desconocidos protegidos',
    'settings.facts.protectedHint': 'Separados por comas. El agente nunca afirmará nada sobre estos temas.',
    'settings.facts.facts': 'Hechos',
    'settings.facts.id': 'Id',
    'settings.facts.text': 'Texto',
    'settings.facts.source': 'Fuente',
    'settings.facts.effectiveAt': 'Vigente desde',
    'settings.facts.expiresAt': 'Caduca (opcional)',
    'settings.facts.addFact': 'Añadir hecho',
    'settings.facts.removeFact': 'Quitar',
    'settings.facts.save': 'Guardar como nueva revisión',
    'settings.facts.saving': 'Guardando…',
    'settings.facts.savedDraft': 'Revisión {n} guardada, todavía sin aprobar',
    'settings.facts.approve': 'Aprobar revisión {n}',
    'settings.facts.approvedToast': 'Revisión aprobada: el agente ya la usa',
    'settings.facts.history': 'Historial',
    'settings.facts.historyRow': 'Revisión {n} · {who} · {when}',
    'settings.facts.agent': 'el agente',
    'settings.facts.agentDraft': 'El agente ha preparado la revisión {n} a partir de tu web. Revisa cada dato, corrige lo que no esté bien (se guarda como una revisión nueva) y apruébala.',
    'settings.facts.isApproved': 'Aprobada',
    'settings.facts.isDraft': 'Sin aprobar',
    'settings.facts.published.title': 'Datos publicados',
    'settings.facts.published.explain': 'Vienen de la web del negocio y se editan allí, no aquí.',
    'settings.facts.published.synced': 'sincronizado {when}',
    'settings.facts.published.count': '{n} datos',
    'settings.facts.published.list': 'Ver los datos',
    'settings.facts.published.protectedFromSite': 'Publicados en la web del negocio.',
    'settings.facts.published.noProtected': 'Ninguno',
    'settings.tab.audit': 'Registro',

    'settings.tabDesc.general': 'El nombre y la zona horaria de la marca, las reglas para aprobar y cómo se prepara lo que se publica.',
    'settings.tabDesc.members': 'Quién trabaja en esta marca y qué puede hacer cada uno.',
    'settings.tabDesc.accounts': 'Las cuentas de cada red. Las conectadas las publica la app sola; las demás se publican a mano.',
    'settings.tabDesc.schedule': 'Cuándo quieres publicar cada semana, y los días en que no se publica nada.',
    'settings.tabDesc.agent': 'El agente convierte una petición de cambios en una versión nueva sin que nadie se la pase. Nunca aprueba ni programa, y estos límites se comprueban aquí: ningún runner se los puede saltar.',
    'settings.tabDesc.webhooks': 'Avisan a otros sistemas de lo que pasa aquí: un runner que arranca el agente cuando se piden cambios, o un script que escribe en un chat.',
    'settings.tabDesc.prizes': 'Quien comenta una palabra clave recibe un archivo o un enlace por mensaje privado, enviado por la app.',
    'settings.tabDesc.notifications': 'Publica en un canal de Slack lo que el equipo tiene que saber.',
    'settings.tabDesc.tokens': 'Un token deja a un agente o a un script producir para esta marca: crear piezas, subir versiones y responder comentarios. Nunca puede aprobar, programar ni cambiar ajustes.',
    'settings.tabDesc.audit': 'Cada aprobación, conexión e intento de publicación, de lo más nuevo a lo más antiguo. Solo se puede añadir, nunca editar.',

    'settings.role.admin': 'Gestiona la marca, las cuentas, los miembros y los tokens de API. Puede hacer todo lo que hace un aprobador.',
    'settings.role.approver': 'Revisa, aprueba o rechaza, programa y mueve fechas, y pausa la marca. No puede aprobar lo que ha subido.',
    'settings.role.reviewer': 'Ve, comenta, pide cambios y resuelve comentarios. No puede aprobar ni programar.',
    'settings.role.producer': 'Crea piezas, sube versiones y responde y resuelve comentarios. No puede aprobar ni programar.',
    'settings.role.reader': 'Ve las piezas, el calendario y los resultados. No puede comentar.',

    // general
    'settings.general.brand': 'Marca',
    'settings.general.name': 'Nombre',
    'settings.general.timezone': 'Zona horaria',
    'settings.general.locale': 'Idioma del contenido',
    'settings.general.localeHint': 'Código del idioma en que publica la marca, como es-ES.',
    'settings.general.rules': 'Reglas de aprobación',
    'settings.general.rulesHint': 'Quien sube una versión nunca puede aprobarla.',
    'settings.general.required': 'Aprobaciones necesarias',
    'settings.general.reapprove': 'Cambiar algo ya programado necesita que lo confirme un segundo aprobador',
    'settings.general.reapproveHint': 'Vale para mover la fecha y para editar el texto.',
    'settings.general.checklist': 'Lista de comprobación',
    'settings.general.checklistHint': 'Un punto por línea. El aprobador marca todos antes de aprobar.',
    'settings.general.checklistPlaceholder': 'Datos comprobados\nNinguna música sin derechos\nSubtítulos revisados',
    'settings.general.publishing': 'Publicación',
    'settings.general.lead': 'Empezar a preparar (minutos antes)',
    'settings.general.leadHint': 'Los archivos se convierten y se envían a la red con este margen. Los contenedores de Instagram duran 24 horas: deja el margen muy por debajo.',
    'settings.general.tolerance': 'Publicar aún con retraso (minutos)',
    'settings.general.toleranceHint': 'Si la app estaba caída a la hora, solo publica dentro de este retraso. Pasado ese tiempo, avisa al equipo en vez de publicar tarde.',
    'settings.general.danger': 'Zona delicada',
    'settings.general.pauseTitle': 'Pausar la marca',
    'settings.general.pauseHint': 'Para una crisis: congela lo programado sin perder las fechas. Mientras esté en pausa no se publica, programa ni mueve nada.',
    'settings.general.pausedTitle': 'La marca está en pausa',
    'settings.general.pausedHint': 'No se publica, programa ni mueve nada hasta que alguien la reanude. Lo programado conserva sus fechas.',
    'settings.general.pausedChip': 'En pausa',
    'settings.general.pause': 'Pausar la marca',
    'settings.general.resume': 'Reanudar la marca',
    'settings.general.pauseAsk': '¿Pausar {brand}?',
    'settings.general.pauseConfirm': 'No se publicará, programará ni moverá nada hasta que alguien la reanude.',
    'settings.general.paused': 'Marca en pausa',
    'settings.general.resumed': 'Marca reanudada',

    // members
    'settings.members.title': 'Miembros',
    'settings.members.count': { one: '{count} persona', other: '{count} personas' },
    'settings.members.role': 'Rol',
    'settings.members.roleOf': 'Rol de {email}',
    'settings.members.2faOn': 'Con autenticador',
    'settings.members.2faOff': 'Sin autenticador',
    'settings.members.you': 'tú',
    'settings.members.reset': 'Quitar autenticador',
    'settings.members.resetConfirm': '{email} tendrá que configurar uno nuevo la próxima vez que entre. Es para quien ha perdido el móvil y los códigos de recuperación.',
    'settings.members.resetDone': 'Autenticador quitado: configurará uno nuevo al entrar',
    'settings.members.remove': 'Quitar de la marca',
    'settings.members.removeConfirm': '{email} dejará de tener acceso a esta marca, y se revocan los tokens de API que creó en ella.',
    'settings.members.roleChanged': 'Rol cambiado',
    'settings.members.addTitle': 'Añadir a una persona',
    'settings.members.addHint': 'Entra con su correo, sin contraseña. Si ya trabaja en otro espacio de trabajo, recibe una invitación.',
    'settings.members.email': 'Correo',
    'settings.members.name': 'Nombre',
    'settings.members.otherBrands': 'La misma persona puede tener otro rol en otra marca.',
    'settings.members.add': 'Añadir',
    'settings.members.emailPlaceholder': 'nombre@empresa.com',
    'settings.members.invited': 'Invitación enviada a {email}: será miembro cuando la acepte',
    'settings.members.removed': 'Quitada de la marca',
    'settings.members.removeTitle': '¿Quitar a {name} de la marca?',
    'settings.members.removeSelfConfirm': 'Dejarás de tener acceso a esta marca, y se revocan los tokens de API que creaste en ella.',
    'settings.members.resetTitle': '¿Quitar el autenticador de {name}?',
    'settings.members.actionsOf': 'Acciones de {name}',
    'settings.members.2faOnHint': 'Entra con un código de su app de autenticación además del correo',
    'settings.members.2faOffHint': 'Entra solo con el enlace que le llega por correo',
    'settings.members.pending': 'Invitaciones pendientes',
    'settings.members.invitedWhen': 'enviada {when}',
    'settings.members.invitedBy': 'por {who}',
    'settings.members.expires': 'caduca el {date}',
    'settings.members.waiting': 'Sin responder',
    'settings.members.cancelInvitation': 'Cancelar invitación',
    'settings.members.cancelTitle': '¿Cancelar la invitación?',
    'settings.members.cancelConfirm': '{email} ya no podrá aceptarla. Puedes volver a invitarle cuando quieras.',
    'settings.members.invitationCancelled': 'Invitación cancelada',
    'settings.members.added': 'Persona añadida: ya puede entrar con su correo',

    // accounts
    'settings.accounts.needsCount': { one: '{count} hay que reconectarla', other: '{count} hay que reconectarlas' },
    'settings.accounts.empty': 'Todavía no hay cuentas',
    'settings.accounts.state.connected': 'Conectada',
    'settings.accounts.state.reconnect': 'Hay que reconectarla',
    'settings.accounts.state.manual': 'A mano',
    'settings.accounts.notAutomated': 'Este servidor aún no puede publicar en {network}: se publica a mano.',
    'settings.accounts.missingScopes': 'Faltan permisos: {scopes}',
    'settings.accounts.missingScopesFail': 'Faltan permisos: {scopes}. Publicar fallará hasta que se concedan.',
    'settings.accounts.accessUntil': 'El acceso de la red dura hasta el {date}',
    'settings.accounts.checked': 'comprobada {when}',
    'settings.accounts.approval.youtube': 'Google ha auditado este proyecto',
    'settings.accounts.approval.tiktok': 'TikTok ha auditado esta app',
    'settings.accounts.approval.pinterest': 'Pinterest ha dado acceso Standard a esta app',
    'settings.accounts.approvalUntil.youtube': 'hasta entonces los vídeos se suben como privados',
    'settings.accounts.approvalUntil.tiktok': 'hasta entonces las publicaciones son privadas, solo las ve la cuenta',
    'settings.accounts.approvalUntil.pinterest': 'hasta entonces los pines no los ve nadie más',
    'settings.accounts.check': 'Comprobar',
    'settings.accounts.connect': 'Conectar',
    'settings.accounts.connectN': { one: 'Conectar {count}', other: 'Conectar {count}' },
    'settings.accounts.reconnect': 'Reconectar',
    'settings.accounts.renew': 'Renovar',
    'settings.accounts.disconnect': 'Desconectar',
    'settings.accounts.disconnectConfirm': 'La app dejará de publicar en {name} ({network}): volverá a publicarse a mano hasta que la conectes otra vez.',
    'settings.accounts.disconnected': 'Desconectada: vuelve a publicarse a mano',
    'settings.accounts.removeConfirm': 'La cuenta de {network} desaparece de la marca junto con sus huecos semanales. Solo se puede quitar una cuenta que no tenga publicaciones.',
    'settings.accounts.connectTitle': 'Conectar una red',
    'settings.accounts.connectProvider': 'Conectar {name}',
    'settings.accounts.serverReady': '¿Está listo el servidor?',
    'settings.accounts.manualTitle': 'Añadir una cuenta para publicar a mano',
    'settings.accounts.manualHint': 'Sale en el calendario y en «Publicar hoy»; la app prepara el paquete y una persona lo publica.',
    'settings.accounts.network': 'Red',
    'settings.accounts.displayName': 'Nombre visible',
    'settings.accounts.handle': 'Usuario o ID',
    'settings.accounts.add': 'Añadir cuenta',
    'settings.accounts.manualAdded': 'Cuenta añadida',
    'settings.accounts.connectError': 'No se ha podido conectar: {error}',
    'settings.accounts.reconnectTitle': 'Reconectar {name}',
    'settings.accounts.chooseTitle': 'Elige qué conectar',
    'settings.accounts.chooseSame': 'Elige la misma cuenta que estás reconectando. Si eliges otra, se rechaza.',
    'settings.accounts.chooseHint': 'El inicio de sesión ha encontrado estas. Conecta solo aquellas en las que esta marca debe publicar.',
    'settings.accounts.noMatch': 'El inicio de sesión no ha encontrado ninguna cuenta que encaje.',
    'settings.accounts.alreadyHere': 'ya está aquí, se renovará su conexión',
    'settings.accounts.reconnected': 'Reconectada',
    'settings.accounts.connectedToast': 'Conectada',
    'settings.accounts.credentialsHint': '{name} no tiene página de inicio de sesión para apps: se conecta con una contraseña de app que creas en la propia red. Se guarda cifrada y no se vuelve a mostrar.',
    'settings.accounts.checking': 'Comprobando…',
    'settings.accounts.continue': 'Continuar',
    'settings.accounts.actionsOf': 'Acciones de {name}',
    'settings.accounts.groupConnected': 'Conectadas',
    'settings.accounts.groupManual': 'A mano',
    'settings.accounts.groupManualHint': 'Sin conectar: la app avisa cuando toca y prepara el texto y los archivos; una persona las publica.',
    'settings.accounts.events.on': 'Meta avisa de cada comentario al momento',
    'settings.accounts.events.off': 'Meta no avisa de los comentarios: se leen cada pocos minutos.',
    'settings.accounts.kids': 'Contenido para niños',
    'settings.accounts.kidsHint': 'Lo que YouTube propone en cada vídeo nuevo de este canal',
    'settings.accounts.kidsAsk': 'Preguntar en cada vídeo',
    'settings.accounts.kidsNo': 'No es para niños',
    'settings.accounts.kidsYes': 'Es para niños',
    'settings.accounts.noneConfigured': 'Para conectar redes hay que configurar sus apps en el servidor',
    'settings.accounts.noneConfiguredHint': 'Cada red necesita las credenciales de una app de desarrollador. Mientras tanto, todo se publica a mano.',
    'settings.accounts.someUnconfigured': 'Sin configurar en este servidor: {names}.',
    'settings.accounts.setupDocs': 'Cómo configurarlas',
    'settings.accounts.removeFromBrand': 'Quitar de la marca',
    'settings.accounts.removeTitle': '¿Quitar {name} de la marca?',
    'settings.accounts.removed': 'Cuenta quitada',
    'settings.accounts.disconnectTitle': '¿Desconectar {name}?',

    'settings.provider.meta': 'Facebook e Instagram',
    'settings.cred.bluesky.handle': 'Usuario',
    'settings.cred.bluesky.handle.help': 'Por ejemplo, lumen.bsky.social',
    'settings.cred.bluesky.appPassword': 'Contraseña de app',
    'settings.cred.bluesky.appPassword.help': 'Se crea en Bluesky, en Ajustes → Privacidad y seguridad → Contraseñas de app. No es la contraseña de tu cuenta.',
    'settings.cred.bluesky.server': 'Servidor',
    'settings.cred.bluesky.server.help': 'Solo si la cuenta no está en bsky.social',

    // readiness checks
    'settings.check.pass': 'Bien',
    'settings.check.warn': 'Échale un ojo',
    'settings.check.fail': 'Hay que arreglarlo',
    'settings.check.skip': 'Sin comprobar',
    'settings.check.sumPass': { one: '{count} bien', other: '{count} bien' },
    'settings.check.sumWarn': { one: '{count} para mirar', other: '{count} para mirar' },
    'settings.check.sumFail': { one: '{count} para arreglar', other: '{count} para arreglar' },
    'settings.check.sumSkip': { one: '{count} sin comprobar', other: '{count} sin comprobar' },
    'settings.check.serverTitle': '¿Está listo el servidor?',
    'settings.check.accountTitle': 'Comprobar {network} · {name}',
    'settings.check.checking': 'Comprobando…',
    'settings.check.asking': 'Preguntando a la red…',
    'settings.check.again': 'Volver a comprobar',
    'settings.check.readOnly': 'Estas comprobaciones solo leen. Para hacer una publicación de prueba de verdad en la cuenta, lanza la comprobación por línea de comandos con',

    // calendar
    'settings.schedule.slots': 'Parrilla semanal',
    'settings.schedule.slotsHint': 'Días y horas en que quieres publicar en cada cuenta. Si se acerca uno sin nada programado, aparece como pendiente en el calendario y puede avisar al agente.',
    'settings.schedule.day': 'Día',
    'settings.schedule.time': 'Hora',
    'settings.schedule.account': 'Cuenta',
    'settings.schedule.label': 'Etiqueta',
    'settings.schedule.labelPlaceholder': 'Reel de la semana',
    'settings.schedule.noLabel': 'Sin etiqueta',
    'settings.schedule.remove': 'Quitar',
    'settings.schedule.removeConfirm': 'El hueco de los {day} a las {time} deja de aparecer en el calendario. Lo ya programado no se toca.',
    'settings.schedule.addTitle': 'Añadir un hueco',
    'settings.schedule.needAccount': 'Primero añade una cuenta en Cuentas: cada hueco es de una cuenta.',
    'settings.schedule.add': 'Añadir hueco',
    'settings.schedule.added': 'Hueco añadido',
    'settings.schedule.blocked': 'Fechas bloqueadas',
    'settings.schedule.blockedHint': 'Días en que no se publica nada. Los aprobadores los bloquean desde el calendario.',
    'settings.schedule.noBlocked': 'No hay fechas bloqueadas.',
    'settings.schedule.unblock': 'Desbloquear',
    'settings.schedule.example': 'Por ejemplo:',
    'settings.schedule.zone': 'Las horas son de {zone}, la zona horaria de la marca.',
    'settings.schedule.labelHint': 'La etiqueta dice qué debería salir, como «Reel de la semana»: se ve en el calendario y la recibe el agente.',
    'settings.schedule.removeTitle': '¿Quitar este hueco?',
    'settings.schedule.removeLabel': 'Quitar el hueco de los {day} a las {time}',
    'settings.schedule.noReason': 'Sin motivo',

    // agent
    'settings.agent.working': 'Trabajando',
    'settings.agent.notStarted': 'No arrancó',
    'settings.agent.noBudget': 'El agente no arrancará hasta que estén los dos presupuestos: gastar es una decisión, no un valor por defecto.',
    'settings.agent.month': 'Este mes',
    'settings.agent.spent': 'Gastado',
    'settings.agent.monthBudget': 'Presupuesto del mes',
    'settings.agent.noLimit': 'Sin fijar',
    'settings.agent.recentRuns': 'Ejecuciones recientes',
    'settings.agent.uploadedOf': { one: '· {count} con versión nueva', other: '· {count} con versión nueva' },
    'settings.agent.share': 'Parte del presupuesto mensual gastada',
    'settings.agent.spentOf': 'Gastado {spent} de {budget} este mes',
    'settings.agent.limits': 'Límites',
    'settings.agent.limitsHint': 'El agente se para en cuanto llega a uno: la pieza pasa a una persona.',
    'settings.agent.rounds': 'Rondas por pieza',
    'settings.agent.roundsHint': 'Tras estas rondas, la pieza va a una persona en vez de volver al agente.',
    'settings.agent.minutes': 'Ejecución más larga (minutos)',
    'settings.agent.minutesHint': 'El runner para al agente pasado este tiempo.',
    'settings.agent.budgetPiece': 'Presupuesto por pieza ({currency})',
    'settings.agent.budgetPieceHint': 'Lo que el agente puede gastar en una pieza, en total.',
    'settings.agent.budgetMonth': 'Presupuesto al mes ({currency})',
    'settings.agent.budgetMonthHint': 'Lo que puede gastar en toda la marca cada mes natural.',
    'settings.agent.currency': 'Moneda',
    'settings.agent.slots': 'Pedir contenido para un hueco vacío (días antes)',
    'settings.agent.slotsHint': 'Un hueco del calendario que sigue vacío estos días antes de su fecha se anuncia como evento. 0 lo apaga.',
    'settings.agent.runs': 'Últimas ejecuciones',
    'settings.agent.noRuns': 'El agente todavía no se ha ejecutado.',
    'settings.agent.when': 'Cuándo',
    'settings.agent.piece': 'Pieza',
    'settings.agent.pieceFallback': 'Pieza',
    'settings.agent.newPiece': 'Pieza nueva',
    'settings.agent.startedBy': 'Lo lanzó',
    'settings.agent.result': 'Resultado',
    'settings.agent.cost': 'Coste',

    // webhooks
    'settings.webhooks.title': 'Webhooks',
    'settings.webhooks.count': { one: '{count} webhook', other: '{count} webhooks' },
    'settings.webhooks.add': 'Añadir un webhook',
    'settings.webhooks.addShort': 'Añadir webhook',
    'settings.webhooks.editTitle': 'Editar webhook',
    'settings.webhooks.empty': 'Todavía no hay webhooks',
    'settings.webhooks.emptyHint': 'Añade uno para que un runner o un script reaccione a lo que pasa aquí.',
    'settings.webhooks.active': 'Activo',
    'settings.webhooks.disabled': 'Desactivado',
    'settings.webhooks.failing': 'Fallando',
    'settings.webhooks.secretEnding': 'Secreto acabado en {hint}',
    'settings.webhooks.lastDelivered': 'última entrega {when}',
    'settings.webhooks.waiting': { one: '{count} en espera', other: '{count} en espera' },
    'settings.webhooks.failedDay': { one: '{count} entrega fallida en el último día', other: '{count} entregas fallidas en el último día' },
    'settings.webhooks.test': 'Enviar una prueba',
    'settings.webhooks.testSent': 'Prueba enviada',
    'settings.webhooks.deliveries': 'Entregas',
    'settings.webhooks.disable': 'Desactivar',
    'settings.webhooks.enable': 'Activar',
    'settings.webhooks.rotate': 'Nuevo secreto',
    'settings.webhooks.rotateTitle': '¿Crear un secreto nuevo?',
    'settings.webhooks.rotateConfirm': 'El anterior deja de valer al momento: actualiza el receptor enseguida.',
    'settings.webhooks.deleteTitle': '¿Borrar este webhook?',
    'settings.webhooks.deleteConfirm': 'Se borra también su historial de entregas, y esta dirección deja de recibir avisos:',
    'settings.webhooks.actions': 'Más acciones del webhook',
    'settings.webhooks.address': 'Dirección',
    'settings.webhooks.addressHint': 'Adónde se envían los eventos, por ejemplo el runner: https://runner.example.com/webhooks/estudio',
    'settings.webhooks.description': 'Descripción',
    'settings.webhooks.events': 'Eventos',
    'settings.webhooks.secretHint': 'Es la única vez que se muestra el secreto. El receptor lo usa para comprobar que una entrega sale de aquí: calcula un HMAC-SHA256 de «timestamp.body» con este secreto y lo compara con la cabecera de firma.',
    'settings.webhooks.copySecret': 'Copiar secreto',
    'settings.webhooks.copySecretTitle': 'Copia el secreto ahora',
    'settings.webhooks.newSecretTitle': 'Secreto nuevo',
    'settings.webhooks.retryHint': 'Una entrega fallida se reintenta con esperas cada vez más largas durante 24 horas; después se abandona.',
    'settings.webhooks.nothingSent': 'Todavía no se ha enviado nada',
    'settings.webhooks.nothingSentHint': 'Usa «Enviar una prueba» para comprobar el receptor.',
    'settings.webhooks.when': 'Cuándo',
    'settings.webhooks.event': 'Evento',
    'settings.webhooks.result': 'Resultado',
    'settings.webhooks.status.delivered': 'Entregada',
    'settings.webhooks.status.pending': 'En espera',
    'settings.webhooks.status.failed': 'Fallida',
    'settings.webhooks.attemptsN': { one: '{count} intento', other: '{count} intentos' },
    'settings.webhooks.nextTry': 'Siguiente intento {when}',
    'settings.webhooks.attempts': 'Intentos',
    'settings.webhooks.sendAgain': 'Reenviar',
    'settings.webhooks.queued': 'En cola para reenviarse',
    'settings.webhooks.answer': 'Respuesta',
    'settings.webhooks.time': 'Tiempo',
    'settings.webhooks.noAnswer': 'sin respuesta',
    'settings.webhooks.eventHelp.version.changes_requested': 'Se han pedido cambios en una versión: los comentarios abiertos con sus marcas y fotogramas. Es lo que arranca un agente.',
    'settings.webhooks.eventHelp.version.approved': 'Se ha aprobado una versión, con las cuentas para las que se aprobó.',
    'settings.webhooks.eventHelp.version.rejected': 'Se ha rechazado una versión, con el motivo.',
    'settings.webhooks.eventHelp.comment.created': 'Alguien ha comentado una versión o ha respondido a un comentario.',
    'settings.webhooks.eventHelp.slot.needs_content': 'Un hueco del calendario sigue vacío pocos días antes de su fecha, con el briefing de la campaña.',
    'settings.webhooks.eventHelp.publication.published': 'Ha salido una publicación (la publicó la app o una persona).',
    'settings.webhooks.eventHelp.publication.failed': 'No se ha podido publicar algo.',

    // Slack
    'settings.slack.title': 'Slack',
    'settings.slack.channel': 'Canal',
    'settings.slack.hint': 'Publica en un canal, una vez para todo el equipo. En Slack, crea un «incoming webhook» para el canal y pega aquí su dirección. La dirección es un secreto: se guarda sellada y no se puede volver a leer, solo sustituir.',
    'settings.slack.on': 'Activo',
    'settings.slack.onHint': 'Activo · …{hint}',
    'settings.slack.off': 'Sin configurar',
    'settings.slack.stopped': 'Parado',
    'settings.slack.unavailable': 'El servidor no tiene TOKEN_KEY, que sella la dirección, así que todavía no se puede configurar Slack.',
    'settings.slack.disabled': 'Slack ha dejado de aceptar mensajes ({reason}). Pega una dirección de webhook nueva para volver a empezar.',
    'settings.slack.lastError': 'El último mensaje falló: {error}',
    'settings.slack.replace': 'Sustituir la dirección del webhook (opcional)',
    'settings.slack.address': 'Dirección del webhook',
    'settings.slack.addressHint': 'Empieza por https://hooks.slack.com/services/',
    'settings.slack.postWhen': 'Publicar cuando…',
    'settings.slack.test': 'Enviar un mensaje de prueba',
    'settings.slack.testOk': 'Enviado: míralo en el canal',
    'settings.slack.testRefused': 'Slack lo ha rechazado: {message}',
    'settings.slack.lastOk': 'Último mensaje publicado {when}.',
    'settings.slack.dangerTitle': 'Zona delicada',
    'settings.slack.removeTitle': 'Quitar Slack',
    'settings.slack.removeHint': 'Se deja de publicar en el canal y se borra la dirección guardada. Para volver, hará falta pegarla otra vez.',
    'settings.slack.remove': 'Quitar Slack',
    'settings.slack.removeAsk': '¿Dejar de publicar en Slack?',
    'settings.slack.removeConfirm': 'Se borra la dirección del webhook de Slack; para volver, tendrás que pegarla otra vez.',
    'settings.slack.removed': 'Slack quitado',

    // API tokens
    'settings.tokens.title': 'Tokens',
    'settings.tokens.count': { one: '{count} token', other: '{count} tokens' },
    'settings.tokens.empty': 'Todavía no hay tokens',
    'settings.tokens.name': 'Nombre',
    'settings.tokens.namePlaceholder': 'Agente de vídeo',
    'settings.tokens.created': 'creado {when}',
    'settings.tokens.revoked': 'Revocado',
    'settings.tokens.expired': 'Caducado',
    'settings.tokens.revoke': 'Revocar',
    'settings.tokens.revokeConfirm': 'Deja de funcionar al momento: el agente o el script que lo use ya no podrá entrar.',
    'settings.tokens.revokedToast': 'Token revocado',
    'settings.tokens.newTitle': 'Token nuevo',
    'settings.tokens.days': 'Válido durante (días)',
    'settings.tokens.create': 'Crear token',
    'settings.tokens.copyTitle': 'Copia el token ahora',
    'settings.tokens.copyHint': 'Es la única vez que se muestra. Se guarda como hash, así que nadie (ni nosotros) puede volver a leerlo.',
    'settings.tokens.copy': 'Copiar token',
    'settings.tokens.actionsOf': 'Acciones de {name}',
    'settings.tokens.activeUntil': 'Activo hasta el {date}',
    'settings.tokens.createdBy': 'Creado por {who} {when}',
    'settings.tokens.usedWhen': 'último uso {when}',
    'settings.tokens.neverUsed': 'sin usar todavía',
    'settings.tokens.newHint': 'Se muestra una sola vez, al crearlo: cópialo entonces en el runner del agente o en el script que lo vaya a usar.',
    'settings.tokens.revokeTitle': '¿Revocar «{name}»?',

    // audit log
    'settings.audit.title': 'Registro',
    'settings.audit.count': { one: 'El último movimiento', other: 'Los últimos {count} movimientos' },
    'settings.audit.empty': 'Todavía no hay nada en el registro',
    'settings.audit.when': 'Cuándo',
    'settings.audit.who': 'Quién',
    'settings.audit.what': 'Qué',
    'settings.audit.detail': 'Detalle',
    'settings.audit.system': 'sistema',
  },
  en: {
    'settings.title': 'Settings',
    'settings.sections': 'Settings sections',
    'settings.needsAttention': '(needs attention)',
    'settings.saved': 'Saved',
    'settings.unsaved': 'Unsaved changes',
    'settings.discard': 'Discard changes',
    'settings.dismiss': 'Dismiss',
    'settings.done': 'Done',
    'settings.actions': 'Actions',

    'settings.group.brand': 'Brand',
    'settings.group.automation': 'Automation',
    'settings.group.control': 'Control',

    'settings.tab.general': 'General',
    'settings.tab.members': 'People',
    'settings.tab.accounts': 'Accounts',
    'settings.tab.schedule': 'Weekly plan',
    'settings.tab.agent': 'Agent',
    'settings.tab.webhooks': 'Webhooks',
    'settings.tab.prizes': 'Prizes',
    'settings.tab.notifications': 'Slack',
    'settings.tab.tokens': 'API tokens',
    'settings.tab.media': 'Media library',
    'settings.tabDesc.media': 'Your photos and videos, and which ones the agent may use in drafts',
    'settings.media.title': 'Your originals',
    'settings.media.intro': "The brand's own photos and videos. Uploading a file permits nothing: a person decides, per file, whether the agent may use it in drafts, and can withdraw that at any time. Once allowed, the agent describes what it sees under \"What the agent sees\". It will only say about the photo what that description says, so correct it if something is wrong.",
    'settings.media.empty': 'No originals yet',
    'settings.media.emptyHint': 'Upload a photo or video of your own and decide whether the agent may use it.',
    'settings.media.allowedCount': '{allowed} of {total} allowed for the agent',
    'settings.media.image': 'Image',
    'settings.media.video': 'Video',
    'settings.media.allowed': 'Allowed for the agent',
    'settings.media.allowedBy': 'by {who}, {when}',
    'settings.media.withdrawnBy': 'Withdrawn by {who}, {when}',
    'settings.media.notAllowed': 'Not allowed for the agent',
    'settings.media.uploadedBy': 'Uploaded by {who}, {when}',
    'settings.media.allow': 'Allow in drafts',
    'settings.media.withdraw': 'Withdraw permission',
    'settings.media.archive': 'Archive',
    'settings.media.archiveTitle': 'Archive “{name}”?',
    'settings.media.archiveConfirm': 'The agent stops seeing it. Versions that already use it do not change.',
    'settings.media.allowedToast': 'The agent may use it now',
    'settings.media.withdrawnToast': 'Permission withdrawn',
    'settings.media.archivedToast': 'Archived',
    'settings.media.uploaded': 'Original kept. Now decide whether the agent may use it.',
    'settings.media.uploadTitle': 'Upload an original',
    'settings.media.uploadHint': 'A real PNG, JPEG or MP4 (the file is checked, not its name). Up to 20 MB for an image, 256 MB for a video.',
    'settings.media.fileAria': 'File',
    'settings.media.upload': 'Upload',
    'settings.media.uploading': 'Uploading…',
    'settings.media.progress.hashing': 'Computing the fingerprint… {pct}%',
    'settings.media.progress.uploading': 'Uploading… {pct}%',
    'settings.media.progress.closing': 'Checking what was stored…',
    'settings.media.sees': 'What the agent sees',
    'settings.media.seesPending': 'The agent will describe it on its next round.',
    'settings.media.seesByPerson': 'Corrected by {who}, {when}',
    'settings.media.seesByAgent': 'Written by the agent, {when}',
    'settings.media.correct': 'Correct',
    'settings.media.describe': 'Describe',
    'settings.media.descriptionAria': 'What is in the photo',
    'settings.media.tagsAria': 'Tags, separated by commas',
    'settings.media.agentSuggested': 'The agent suggested: {tags}. Type above only the ones that are right.',
    'settings.media.save': 'Save',
    'settings.media.cancel': 'Cancel',
    'settings.media.describedToast': 'Description saved: the agent will use this one',
    'settings.tab.facts': 'Business facts',
    'settings.tabDesc.facts': 'What the agent knows about your business: only approved facts, never invented ones',
    'settings.facts.title': 'Business facts',
    'settings.facts.intro': 'The agent plans only with the facts approved here and never invents others. Anything listed as a protected unknown it will never assert. Every change is a new revision someone must approve.',
    'settings.facts.none': 'No approved facts yet',
    'settings.facts.approved': 'Revision {n} approved by {who}, {when}',
    'settings.facts.formTitle': 'Edit',
    'settings.facts.businessName': 'Business name',
    'settings.facts.category': 'Category',
    'settings.facts.goal': 'Goal',
    'settings.facts.audience': 'Audience',
    'settings.facts.voice': 'Voice',
    'settings.facts.cta': 'Call to action',
    'settings.facts.protectedWordHint': "Avoid '{word}' here: the agent cannot use that word in its own copy.",
    'settings.facts.protectedUnknowns': 'Protected unknowns',
    'settings.facts.protectedHint': 'Comma-separated. The agent will never assert anything about these topics.',
    'settings.facts.facts': 'Facts',
    'settings.facts.id': 'Id',
    'settings.facts.text': 'Text',
    'settings.facts.source': 'Source',
    'settings.facts.effectiveAt': 'Effective from',
    'settings.facts.expiresAt': 'Expires (optional)',
    'settings.facts.addFact': 'Add fact',
    'settings.facts.removeFact': 'Remove',
    'settings.facts.save': 'Save as new revision',
    'settings.facts.saving': 'Saving…',
    'settings.facts.savedDraft': 'Revision {n} saved, not yet approved',
    'settings.facts.approve': 'Approve revision {n}',
    'settings.facts.approvedToast': 'Revision approved: the agent uses it now',
    'settings.facts.history': 'History',
    'settings.facts.historyRow': 'Revision {n} · {who} · {when}',
    'settings.facts.agent': 'the agent',
    'settings.facts.agentDraft': 'The agent drafted revision {n} from your website. Check each fact, correct what is wrong (that saves a new revision) and approve it.',
    'settings.facts.isApproved': 'Approved',
    'settings.facts.isDraft': 'Not approved',
    'settings.facts.published.title': 'Published facts',
    'settings.facts.published.explain': "These come from the business's website and are edited there, not here.",
    'settings.facts.published.synced': 'synced {when}',
    'settings.facts.published.count': '{n} facts',
    'settings.facts.published.list': 'Show the facts',
    'settings.facts.published.protectedFromSite': "Published on the business's website.",
    'settings.facts.published.noProtected': 'None',
    'settings.tab.audit': 'Audit log',

    'settings.tabDesc.general': "The brand's name and time zone, the approval rules and how what is published gets prepared.",
    'settings.tabDesc.members': 'Who works on this brand and what each of them can do.',
    'settings.tabDesc.accounts': "Each network's accounts. Connected ones are published to by the app itself; the rest are published by hand.",
    'settings.tabDesc.schedule': 'When you want to post each week, and the days nothing is published.',
    'settings.tabDesc.agent': 'The agent turns a request for changes into a new version without anyone passing it on. It can never approve or schedule, and these limits are checked here, so no runner can skip them.',
    'settings.tabDesc.webhooks': 'Webhooks tell other systems what happens here: for example a runner that starts an agent when changes are requested, or a script that posts to chat.',
    'settings.tabDesc.prizes': 'Whoever comments a keyword gets a file or a link by private message, sent by the app.',
    'settings.tabDesc.notifications': 'Posts what the team needs to know to a Slack channel.',
    'settings.tabDesc.tokens': 'A token lets an agent or a script produce for this brand: create pieces, upload versions and answer comments. It can never approve, schedule or change settings.',
    'settings.tabDesc.audit': 'Every approval, connection and publication attempt, newest first. It can only be added to, never edited.',

    'settings.role.admin': 'Manages the brand, accounts, members and API tokens. Can do everything an approver can.',
    'settings.role.approver': 'Reviews, approves or rejects, schedules and moves dates, pauses the brand. Cannot approve what they uploaded.',
    'settings.role.reviewer': 'Views, comments, requests changes and resolves comments. Cannot approve or schedule.',
    'settings.role.producer': 'Creates pieces, uploads versions, replies to and resolves comments. Cannot approve or schedule.',
    'settings.role.reader': 'Views pieces, calendar and results. Cannot comment.',

    // general
    'settings.general.brand': 'Brand',
    'settings.general.name': 'Name',
    'settings.general.timezone': 'Time zone',
    'settings.general.locale': 'Content language',
    'settings.general.localeHint': 'Code of the language the brand publishes in, such as en-GB.',
    'settings.general.rules': 'Approval rules',
    'settings.general.rulesHint': 'Whoever uploaded a version can never approve it.',
    'settings.general.required': 'Approvals needed',
    'settings.general.reapprove': 'Changing something already scheduled needs a second approver to confirm',
    'settings.general.reapproveHint': 'Applies to moving the date and to editing the text.',
    'settings.general.checklist': 'Checklist',
    'settings.general.checklistHint': 'One item per line. The approver ticks every item before approving.',
    'settings.general.checklistPlaceholder': 'Facts verified\nNo music we do not have rights to\nSubtitles reviewed',
    'settings.general.publishing': 'Publishing',
    'settings.general.lead': 'Start preparing (minutes before the hour)',
    'settings.general.leadHint': 'Files are converted and sent to the network this long before the scheduled time. Instagram containers last 24 hours, so keep it well under that.',
    'settings.general.tolerance': 'Still publish up to (minutes late)',
    'settings.general.toleranceHint': 'If the app was down at the hour, it publishes only within this delay. After that it tells the team instead of posting late.',
    'settings.general.danger': 'Danger zone',
    'settings.general.pauseTitle': 'Pause everything',
    'settings.general.pauseHint': 'For a crisis: freezes what is scheduled without losing the dates. Nothing can be published, scheduled or moved while paused.',
    'settings.general.pausedTitle': 'The brand is paused',
    'settings.general.pausedHint': 'Nothing is published, scheduled or moved until someone resumes it. What is scheduled keeps its dates.',
    'settings.general.pausedChip': 'Paused',
    'settings.general.pause': 'Pause brand',
    'settings.general.resume': 'Resume brand',
    'settings.general.pauseAsk': 'Pause {brand}?',
    'settings.general.pauseConfirm': 'Nothing will be published, scheduled or moved until someone resumes it.',
    'settings.general.paused': 'Brand paused',
    'settings.general.resumed': 'Brand resumed',

    // members
    'settings.members.title': 'People',
    'settings.members.count': { one: '{count} person', other: '{count} people' },
    'settings.members.role': 'Role',
    'settings.members.roleOf': 'Role of {email}',
    'settings.members.2faOn': 'Authenticator',
    'settings.members.2faOff': 'No authenticator',
    'settings.members.you': 'you',
    'settings.members.reset': 'Reset authenticator',
    'settings.members.resetConfirm': '{email} will set up a new one the next time they sign in. It is for someone who lost their phone and their recovery codes.',
    'settings.members.resetDone': 'Authenticator removed: they set one up again at their next sign-in',
    'settings.members.remove': 'Remove from the brand',
    'settings.members.removeConfirm': '{email} loses access to this brand, and the API tokens they created in it are revoked.',
    'settings.members.roleChanged': 'Role changed',
    'settings.members.addTitle': 'Add a person',
    'settings.members.addHint': 'They sign in with their email, with no password. Someone who already works in another workspace gets an invitation.',
    'settings.members.email': 'Email',
    'settings.members.name': 'Name',
    'settings.members.otherBrands': 'The same person can have a different role in another brand.',
    'settings.members.add': 'Add',
    'settings.members.emailPlaceholder': 'name@company.com',
    'settings.members.invited': 'Invitation sent to {email}: they become a member when they accept it',
    'settings.members.removed': 'Removed from the brand',
    'settings.members.removeTitle': 'Remove {name} from the brand?',
    'settings.members.removeSelfConfirm': 'You lose access to this brand, and the API tokens you created in it are revoked.',
    'settings.members.resetTitle': "Remove {name}'s authenticator?",
    'settings.members.actionsOf': 'Actions for {name}',
    'settings.members.2faOnHint': 'Signs in with a code from their authenticator app as well as the email',
    'settings.members.2faOffHint': 'Signs in with the emailed link only',
    'settings.members.pending': 'Pending invitations',
    'settings.members.invitedWhen': 'sent {when}',
    'settings.members.invitedBy': 'by {who}',
    'settings.members.expires': 'expires {date}',
    'settings.members.waiting': 'No answer yet',
    'settings.members.cancelInvitation': 'Cancel invitation',
    'settings.members.cancelTitle': 'Cancel the invitation?',
    'settings.members.cancelConfirm': '{email} will no longer be able to accept it. You can invite them again whenever you like.',
    'settings.members.invitationCancelled': 'Invitation cancelled',
    'settings.members.added': 'Member added: they can sign in with their email',

    // accounts
    'settings.accounts.needsCount': { one: '{count} needs reconnecting', other: '{count} need reconnecting' },
    'settings.accounts.empty': 'No accounts yet',
    'settings.accounts.state.connected': 'Connected',
    'settings.accounts.state.reconnect': 'Needs reconnecting',
    'settings.accounts.state.manual': 'By hand',
    'settings.accounts.notAutomated': 'This server cannot publish to {network} yet: it is published by hand.',
    'settings.accounts.missingScopes': 'Missing permissions: {scopes}',
    'settings.accounts.missingScopesFail': 'Missing permissions: {scopes}. Publishing will fail until they are granted.',
    'settings.accounts.accessUntil': 'Network access runs until {date}',
    'settings.accounts.checked': 'checked {when}',
    'settings.accounts.approval.youtube': 'Google has audited this project',
    'settings.accounts.approval.tiktok': 'TikTok has audited this app',
    'settings.accounts.approval.pinterest': 'Pinterest has granted this app Standard access',
    'settings.accounts.approvalUntil.youtube': 'until then videos upload as private',
    'settings.accounts.approvalUntil.tiktok': 'until then posts are made private, visible only to the account',
    'settings.accounts.approvalUntil.pinterest': 'until then pins are not visible to others',
    'settings.accounts.check': 'Check',
    'settings.accounts.connect': 'Connect',
    'settings.accounts.connectN': { one: 'Connect {count}', other: 'Connect {count}' },
    'settings.accounts.reconnect': 'Reconnect',
    'settings.accounts.renew': 'Renew',
    'settings.accounts.disconnect': 'Disconnect',
    'settings.accounts.disconnectConfirm': 'The app stops publishing to {name} ({network}): it goes back to being published by hand until you connect it again.',
    'settings.accounts.disconnected': 'Disconnected: it is published by hand again',
    'settings.accounts.removeConfirm': 'The {network} account leaves the brand together with its weekly slots. Only an account with no posts can be removed.',
    'settings.accounts.connectTitle': 'Connect to a network',
    'settings.accounts.connectProvider': 'Connect {name}',
    'settings.accounts.serverReady': 'Is this server ready?',
    'settings.accounts.manualTitle': 'Add an account to publish by hand',
    'settings.accounts.manualHint': 'It shows on the calendar and in Publish today; the app gets the package ready and a person posts it.',
    'settings.accounts.network': 'Network',
    'settings.accounts.displayName': 'Display name',
    'settings.accounts.handle': 'Handle or ID',
    'settings.accounts.add': 'Add account',
    'settings.accounts.manualAdded': 'Account added',
    'settings.accounts.connectError': 'Could not connect: {error}',
    'settings.accounts.reconnectTitle': 'Reconnect {name}',
    'settings.accounts.chooseTitle': 'Choose what to connect',
    'settings.accounts.chooseSame': 'Pick the same account you are reconnecting. Connecting a different one is refused.',
    'settings.accounts.chooseHint': 'The sign-in found these. Connect only the ones this brand should publish to.',
    'settings.accounts.noMatch': 'The sign-in did not find a matching account.',
    'settings.accounts.alreadyHere': 'already here, its connection will be renewed',
    'settings.accounts.reconnected': 'Reconnected',
    'settings.accounts.connectedToast': 'Connected',
    'settings.accounts.credentialsHint': '{name} has no sign-in page for apps: it is connected with an app password you make in the network itself. The password is kept encrypted and never shown again.',
    'settings.accounts.checking': 'Checking…',
    'settings.accounts.continue': 'Continue',
    'settings.accounts.actionsOf': 'Actions for {name}',
    'settings.accounts.groupConnected': 'Connected',
    'settings.accounts.groupManual': 'By hand',
    'settings.accounts.groupManualHint': 'Not connected: the app says when a post is due and gets the text and files ready; a person publishes it.',
    'settings.accounts.events.on': 'Meta reports every comment as it happens',
    'settings.accounts.events.off': 'Meta does not report the comments: they are read every few minutes.',
    'settings.accounts.kids': 'Made for kids',
    'settings.accounts.kidsHint': 'What YouTube suggests for each new video on this channel',
    'settings.accounts.kidsAsk': 'Ask for each video',
    'settings.accounts.kidsNo': 'Not made for kids',
    'settings.accounts.kidsYes': 'Made for kids',
    'settings.accounts.noneConfigured': 'Connecting networks needs their apps set up on the server',
    'settings.accounts.noneConfiguredHint': "Each network needs a developer app's credentials. Until then, everything is published by hand.",
    'settings.accounts.someUnconfigured': 'Not set up on this server: {names}.',
    'settings.accounts.setupDocs': 'How to set them up',
    'settings.accounts.removeFromBrand': 'Remove from the brand',
    'settings.accounts.removeTitle': 'Remove {name} from the brand?',
    'settings.accounts.removed': 'Account removed',
    'settings.accounts.disconnectTitle': 'Disconnect {name}?',

    'settings.provider.meta': 'Facebook and Instagram',
    'settings.cred.bluesky.handle': 'Handle',
    'settings.cred.bluesky.handle.help': 'For example lumen.bsky.social',
    'settings.cred.bluesky.appPassword': 'App password',
    'settings.cred.bluesky.appPassword.help': 'Made in Bluesky under Settings → Privacy and security → App passwords. Not your account password.',
    'settings.cred.bluesky.server': 'Server',
    'settings.cred.bluesky.server.help': 'Only if the account is not on bsky.social',

    // readiness checks
    'settings.check.pass': 'OK',
    'settings.check.warn': 'Look at this',
    'settings.check.fail': 'Fix this',
    'settings.check.skip': 'Skipped',
    'settings.check.sumPass': { one: '{count} OK', other: '{count} OK' },
    'settings.check.sumWarn': { one: '{count} to look at', other: '{count} to look at' },
    'settings.check.sumFail': { one: '{count} to fix', other: '{count} to fix' },
    'settings.check.sumSkip': { one: '{count} skipped', other: '{count} skipped' },
    'settings.check.serverTitle': 'Is this server ready?',
    'settings.check.accountTitle': 'Check {network} · {name}',
    'settings.check.checking': 'Checking…',
    'settings.check.asking': 'Asking the network…',
    'settings.check.again': 'Check again',
    'settings.check.readOnly': 'These checks only read. To make one real test post on the account, run the command line check with',

    // calendar
    'settings.schedule.slots': 'Weekly plan',
    'settings.schedule.slotsHint': 'The days and times you want to post on each account. When one gets close with nothing scheduled, it shows as pending on the calendar and can tell the agent.',
    'settings.schedule.day': 'Day',
    'settings.schedule.time': 'Time',
    'settings.schedule.account': 'Account',
    'settings.schedule.label': 'Label',
    'settings.schedule.labelPlaceholder': 'Reel of the week',
    'settings.schedule.noLabel': 'No label',
    'settings.schedule.remove': 'Remove',
    'settings.schedule.removeConfirm': 'The {day} {time} slot stops showing on the calendar. Anything already scheduled is left alone.',
    'settings.schedule.addTitle': 'Add a slot',
    'settings.schedule.needAccount': 'Add an account under Accounts first: every slot belongs to one.',
    'settings.schedule.add': 'Add slot',
    'settings.schedule.added': 'Slot added',
    'settings.schedule.blocked': 'Blocked dates',
    'settings.schedule.blockedHint': 'Days when nothing is published. Approvers block them from the calendar.',
    'settings.schedule.noBlocked': 'No blocked dates.',
    'settings.schedule.unblock': 'Unblock',
    'settings.schedule.example': 'For example:',
    'settings.schedule.zone': "Times are in {zone}, the brand's time zone.",
    'settings.schedule.labelHint': 'The label says what should go out, like “Reel of the week”: it shows on the calendar and the agent receives it.',
    'settings.schedule.removeTitle': 'Remove this slot?',
    'settings.schedule.removeLabel': 'Remove the {day} {time} slot',
    'settings.schedule.noReason': 'No reason given',

    // agent
    'settings.agent.working': 'Working',
    'settings.agent.notStarted': 'Not started',
    'settings.agent.noBudget': 'The agent will not start until both budgets are set: spending is a decision, not a default.',
    'settings.agent.month': 'This month',
    'settings.agent.spent': 'Spent',
    'settings.agent.monthBudget': 'Monthly budget',
    'settings.agent.noLimit': 'Not set',
    'settings.agent.recentRuns': 'Recent runs',
    'settings.agent.uploadedOf': { one: '· {count} with a new version', other: '· {count} with a new version' },
    'settings.agent.share': 'Share of the monthly budget spent',
    'settings.agent.spentOf': 'Spent {spent} of {budget} this month',
    'settings.agent.limits': 'Limits',
    'settings.agent.limitsHint': 'The agent stops as soon as it reaches one: the piece goes to a person.',
    'settings.agent.rounds': 'Rounds per piece',
    'settings.agent.roundsHint': 'After this many rounds the piece goes to a person instead of to the agent again.',
    'settings.agent.minutes': 'Longest run (minutes)',
    'settings.agent.minutesHint': 'The runner stops the agent after this long.',
    'settings.agent.budgetPiece': 'Budget per piece ({currency})',
    'settings.agent.budgetPieceHint': 'What the agent may spend on one piece, in total.',
    'settings.agent.budgetMonth': 'Budget per month ({currency})',
    'settings.agent.budgetMonthHint': 'What it may spend across the whole brand each calendar month.',
    'settings.agent.currency': 'Currency',
    'settings.agent.slots': 'Ask for content for an empty slot (days ahead)',
    'settings.agent.slotsHint': 'A calendar slot still empty this many days before its date is announced as an event. 0 turns it off.',
    'settings.agent.runs': 'Recent runs',
    'settings.agent.noRuns': 'The agent has not run yet.',
    'settings.agent.when': 'When',
    'settings.agent.piece': 'Piece',
    'settings.agent.pieceFallback': 'Piece',
    'settings.agent.newPiece': 'New piece',
    'settings.agent.startedBy': 'Started by',
    'settings.agent.result': 'Result',
    'settings.agent.cost': 'Cost',

    // webhooks
    'settings.webhooks.title': 'Webhooks',
    'settings.webhooks.count': { one: '{count} webhook', other: '{count} webhooks' },
    'settings.webhooks.add': 'Add a webhook',
    'settings.webhooks.addShort': 'Add webhook',
    'settings.webhooks.editTitle': 'Edit webhook',
    'settings.webhooks.empty': 'No webhooks yet',
    'settings.webhooks.emptyHint': 'Add one to let a runner or a script react to what happens here.',
    'settings.webhooks.active': 'Active',
    'settings.webhooks.disabled': 'Disabled',
    'settings.webhooks.failing': 'Failing',
    'settings.webhooks.secretEnding': 'Secret ending {hint}',
    'settings.webhooks.lastDelivered': 'last delivered {when}',
    'settings.webhooks.waiting': { one: '{count} waiting', other: '{count} waiting' },
    'settings.webhooks.failedDay': { one: '{count} failed in the last day', other: '{count} failed in the last day' },
    'settings.webhooks.test': 'Send a test',
    'settings.webhooks.testSent': 'Test event sent',
    'settings.webhooks.deliveries': 'Deliveries',
    'settings.webhooks.disable': 'Disable',
    'settings.webhooks.enable': 'Enable',
    'settings.webhooks.rotate': 'New secret',
    'settings.webhooks.rotateTitle': 'Make a new secret?',
    'settings.webhooks.rotateConfirm': 'The old one stops working at once: update the receiver straight away.',
    'settings.webhooks.deleteTitle': 'Delete this webhook?',
    'settings.webhooks.deleteConfirm': 'Its delivery history goes too, and this address stops receiving events:',
    'settings.webhooks.actions': 'More webhook actions',
    'settings.webhooks.address': 'Address',
    'settings.webhooks.addressHint': 'Where the events are sent, for example the runner: https://runner.example.com/webhooks/lumen',
    'settings.webhooks.description': 'Description',
    'settings.webhooks.events': 'Events',
    'settings.webhooks.secretHint': 'This is the only time the secret is shown. The receiver uses it to check that a delivery really comes from here: it computes an HMAC-SHA256 of “timestamp.body” with this secret and compares it with the signature header.',
    'settings.webhooks.copySecret': 'Copy secret',
    'settings.webhooks.copySecretTitle': 'Copy the secret now',
    'settings.webhooks.newSecretTitle': 'New secret',
    'settings.webhooks.retryHint': 'A failed delivery is retried with growing waits for up to 24 hours, then given up on.',
    'settings.webhooks.nothingSent': 'Nothing sent yet',
    'settings.webhooks.nothingSentHint': 'Use “Send a test” to check the receiver.',
    'settings.webhooks.when': 'When',
    'settings.webhooks.event': 'Event',
    'settings.webhooks.result': 'Result',
    'settings.webhooks.status.delivered': 'Delivered',
    'settings.webhooks.status.pending': 'Waiting',
    'settings.webhooks.status.failed': 'Failed',
    'settings.webhooks.attemptsN': { one: '{count} attempt', other: '{count} attempts' },
    'settings.webhooks.nextTry': 'Next try {when}',
    'settings.webhooks.attempts': 'Attempts',
    'settings.webhooks.sendAgain': 'Send again',
    'settings.webhooks.queued': 'Queued to be sent again',
    'settings.webhooks.answer': 'Answer',
    'settings.webhooks.time': 'Time',
    'settings.webhooks.noAnswer': 'no answer',
    'settings.webhooks.eventHelp.version.changes_requested': 'Changes were requested on a version: the open comments with their anchors and frames. This is what starts an agent.',
    'settings.webhooks.eventHelp.version.approved': 'A version was approved, with the accounts it was approved for.',
    'settings.webhooks.eventHelp.version.rejected': 'A version was rejected, with the reason.',
    'settings.webhooks.eventHelp.comment.created': 'Someone commented on a version or replied to a comment.',
    'settings.webhooks.eventHelp.slot.needs_content': 'A calendar slot is still empty a few days before its date, with the campaign brief.',
    'settings.webhooks.eventHelp.publication.published': 'A post went out (by the app or by a person).',
    'settings.webhooks.eventHelp.publication.failed': 'A post could not be published.',

    // Slack
    'settings.slack.title': 'Slack',
    'settings.slack.channel': 'Channel',
    'settings.slack.hint': 'Posts to a channel, once for the team. In Slack, make an “incoming webhook” for the channel and paste its address here. The address is a secret: it is kept sealed and cannot be read back, only replaced.',
    'settings.slack.on': 'On',
    'settings.slack.onHint': 'On · …{hint}',
    'settings.slack.off': 'Not set up',
    'settings.slack.stopped': 'Stopped',
    'settings.slack.unavailable': 'The server has no TOKEN_KEY, which seals the address, so Slack cannot be set up yet.',
    'settings.slack.disabled': 'Slack stopped taking messages ({reason}). Paste a new webhook address to start again.',
    'settings.slack.lastError': 'The last post failed: {error}',
    'settings.slack.replace': 'Replace the webhook address (optional)',
    'settings.slack.address': 'Webhook address',
    'settings.slack.addressHint': 'Starts with https://hooks.slack.com/services/',
    'settings.slack.postWhen': 'Post when…',
    'settings.slack.test': 'Send a test message',
    'settings.slack.testOk': 'Sent: look in the channel',
    'settings.slack.testRefused': 'Slack said no: {message}',
    'settings.slack.lastOk': 'Last message posted {when}.',
    'settings.slack.dangerTitle': 'Danger zone',
    'settings.slack.removeTitle': 'Remove Slack',
    'settings.slack.removeHint': 'Stops posting to the channel and deletes the stored address. To come back, it has to be pasted again.',
    'settings.slack.remove': 'Remove Slack',
    'settings.slack.removeAsk': 'Stop posting to Slack?',
    'settings.slack.removeConfirm': 'The Slack webhook address is deleted; to come back you will have to paste it again.',
    'settings.slack.removed': 'Slack removed',

    // API tokens
    'settings.tokens.title': 'Tokens',
    'settings.tokens.count': { one: '{count} token', other: '{count} tokens' },
    'settings.tokens.empty': 'No tokens yet',
    'settings.tokens.name': 'Name',
    'settings.tokens.namePlaceholder': 'Video agent',
    'settings.tokens.created': 'created {when}',
    'settings.tokens.revoked': 'Revoked',
    'settings.tokens.expired': 'Expired',
    'settings.tokens.revoke': 'Revoke',
    'settings.tokens.revokeConfirm': 'It stops working immediately: the agent or script that uses it can no longer get in.',
    'settings.tokens.revokedToast': 'Token revoked',
    'settings.tokens.newTitle': 'New token',
    'settings.tokens.days': 'Valid for (days)',
    'settings.tokens.create': 'Create token',
    'settings.tokens.copyTitle': 'Copy your token now',
    'settings.tokens.copyHint': 'This is the only time it is shown. It is stored as a hash, so nobody (including us) can read it again.',
    'settings.tokens.copy': 'Copy token',
    'settings.tokens.actionsOf': 'Actions for {name}',
    'settings.tokens.activeUntil': 'Active until {date}',
    'settings.tokens.createdBy': 'Created by {who} {when}',
    'settings.tokens.usedWhen': 'last used {when}',
    'settings.tokens.neverUsed': 'never used yet',
    'settings.tokens.newHint': 'It is shown once, when it is created: copy it then into the agent runner or the script that will use it.',
    'settings.tokens.revokeTitle': 'Revoke “{name}”?',

    // audit log
    'settings.audit.title': 'Audit log',
    'settings.audit.count': { one: 'The latest entry', other: 'The latest {count} entries' },
    'settings.audit.empty': 'Nothing in the log yet',
    'settings.audit.when': 'When',
    'settings.audit.who': 'Who',
    'settings.audit.what': 'What',
    'settings.audit.detail': 'Detail',
    'settings.audit.system': 'system',
  },
});
